(ns ui.hyperframes-templates.devtools
  "The only way to the Templates entry of the editor2 sidebar, and on
   purpose not a way our users can find (see `ui.dark-launch`). From
   the Chrome DevTools console on the editor2 page:

       ui.hyperframes_templates.devtools.enableTemplates()
       ui.hyperframes_templates.devtools.disableTemplates()"
  (:require [ui.dark-launch :as dark-launch]))

(defn ^:export enableTemplates
  []
  (dark-launch/enable! :hyperframes-templates))

(defn ^:export disableTemplates
  []
  (dark-launch/disable! :hyperframes-templates))
